import { useCallback, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { Toast, ToastInput, ToastProviderProps } from '@contexts/toast/toast.type';
import { DEFAULT_INTERVAL, SUCCESS_INTERVAL, ToastContext } from '@contexts/toast/toast-context';

import { ToastContainer } from './components/toast-container';

export const ToastProvider = ({ children }: ToastProviderProps) => {
  const [data, setData] = useState<Array<Toast>>([]);

  const Push = useCallback(
    ({ title, text, lifetime, type, disableTimeOut = false }: ToastInput) => {
      const defaultLifetime = type === 'success' ? SUCCESS_INTERVAL : DEFAULT_INTERVAL;
      const newItem: Toast = {
        id: globalThis.crypto.randomUUID(),
        title,
        text,
        type,
        lifetime: lifetime ?? defaultLifetime,
        disableTimeOut,
      };

      setData((prevState) => [...prevState.filter((toast) => toast.title !== title), newItem]);
    },
    [setData]
  );

  const remove = useCallback((id: string) => {
    setData((prevState) => prevState.filter((e) => e.id !== id));
  }, []);

  const value = useMemo(() => ({ data, push: Push, remove }), [data, Push, remove]);

  return (
    <ToastContext.Provider value={value}>
      {createPortal(<ToastContainer />, document.body as Element)}
      {children}
    </ToastContext.Provider>
  );
};
